import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './styles/theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initAnalytics } from './utils/analytics';
import { isPrerendering } from './utils/prerender';

// Initialize Google Analytics (skip during prerendering)
if (!isPrerendering()) {
  initAnalytics();
}

// Register Service Worker for PWA (skip during prerendering)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production' && !isPrerendering()) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('[Service Worker] Registration successful:', registration.scope);
      })
      .catch((error) => {
        console.log('[Service Worker] Registration failed:', error);
      });
  });
}

const rootElement = document.getElementById('root');

// Support both hydration (for react-snap prerendered pages) and normal rendering
if (rootElement.hasChildNodes()) {
  // If root has content (prerendered by react-snap), use hydrate
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
} else {
  // Otherwise, use normal render
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );
}

// Send Web Vitals to Google Analytics (skip during prerendering)
if (!isPrerendering()) {
  reportWebVitals((metric) => {
    if (window.gtag) {
      window.gtag('event', metric.name, {
        event_category: 'Web Vitals',
        event_label: metric.id,
        value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
        non_interaction: true,
      });
    }
  });
}
